// Highlights whichever link inside a header dropdown matches the page
// currently being viewed — Horizon's own mega-menu markup has no
// active-link class at all (only the top-level nav item gets one), so
// this fills that gap without touching core Horizon files.
(function () {
  var here = window.location.pathname.replace(/\/+$/, '') || '/';

  document.querySelectorAll('.mega-menu__link[href]').forEach(function (link) {
    var linkPath;
    try {
      linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (e) {
      return;
    }
    if (linkPath === here) {
      link.classList.add('is-current-page');
    }
  });
})();

// Aligns each dropdown's left edge to its own trigger link — the dropdown
// no longer stretches full-width, but its CSS positioning context isn't
// the trigger item itself, so it was falling back to a far-left default.
// Calculated directly from real rendered positions instead of relying on
// CSS containment. Horizon's own header-menu component resets this inline
// style shortly after the dropdown opens (as part of its own open
// animation/logic), so a MutationObserver keeps reapplying the correct
// value any time Horizon changes it, rather than setting it once and
// losing the fight a second later.
(function () {
  var applying = false;

  function applyPosition(item) {
    var link = item.querySelector(':scope > .menu-list__link');
    var submenu = item.querySelector(':scope > .menu-list__submenu');
    if (!link || !submenu) return;

    var offsetParent = submenu.offsetParent || document.body;
    var linkRect = link.getBoundingClientRect();
    var parentRect = offsetParent.getBoundingClientRect();
    var left = (linkRect.left - parentRect.left) + 'px';

    if (submenu.style.left === left && submenu.style.right === 'auto') return;

    applying = true;
    submenu.style.left = left;
    submenu.style.right = 'auto';
    applying = false;
  }

  var items = Array.prototype.slice.call(document.querySelectorAll('.menu-list__list-item'));

  items.forEach(function (item) {
    var submenu = item.querySelector(':scope > .menu-list__submenu');
    if (!submenu) return;

    applyPosition(item);

    new MutationObserver(function () {
      if (applying) return;
      applyPosition(item);
    }).observe(submenu, { attributes: true, attributeFilter: ['style'] });

    item.addEventListener('pointerenter', function () { applyPosition(item); });
    item.addEventListener('focusin', function () { applyPosition(item); });
  });

  window.addEventListener('resize', function () {
    items.forEach(applyPosition);
  });
})();
